import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import Navbar from "../../Components/Navbar";
import {
  Bg,
  BoxContainer,
  Underline,
} from "../../Components/Styles/PageStyles";
import {
  FieldWrapper,
  InputGroup,
  Label,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import NotFoundModel from "../../Components/NotFoundModel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import moment from "moment";
import SideModal from "../../Components/SideModal";
import FilterModal from "../../Components/FilterModals/FilterModal";
import Table from "../../Components/LatestOwners/Table";
import ActivityLogsModal from "../../Components/ActiveLogs/ActivityLogsModal";
import { toast } from "react-toastify";

const LatestOwners = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [showLogs, setShowLogs] = useState(false);
  const [activityLogs, setActivityLogs] = useState([]);
  const [logsLoading, setLogsLoading] = useState(false);
  const [selectedData, setSelectedData] = useState("");
  const [fetchData, setFetchData] = useState([]);
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState("mobile");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [advancedFilter, setAdvancedFilter] = useState("");
  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(60, "days").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD"),
  );
  const { t } = useTranslation();

  const initialValues = {
    name: "",
    payuKey: "",
    payuMid: "",
    email: "",
    clintId: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(60, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const fetchFunction = async () => {
    const body = new FormData();
    body.append("filterType", filter);
    body.append("filterValue", filterValue);
    if (advancedFilter.startsWith("MODE_")) {
      body.append("filterType", "paymentMode");
      body.append("filterValue", advancedFilter.replace("MODE_", ""));
    }
    body.append("startDate", startDate);
    body.append("advancedFilter", advancedFilter);
    body.append("endDate", endDate);

    return await axios.post(`${Config.apiUrl}/getlatestowners`, body, {
      headers: {
        authorization: "Bearer " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getOwnersSuccess = (res) => {
    if (res.data.status === "NOK" || res.data.data === false) {
      error = true;
    } else setFetchData(res.data.data);
  };

  const getOwnersError = (res) => { };

  const {
    isLoading: isLoadings,
    mutate: getOwnersMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getOwnersSuccess,
    onError: getOwnersError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getOwnersMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [filterValue, startDate, endDate, advancedFilter]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    getOwnersMutate();
  };
  const ChangeHandler = (e) => {
    setFilterValue(e.target.value);
    if (advancedFilter.startsWith("MODE_")) {
      setAdvancedFilter("");
    }
  };

  // ---- Activity Logs -------------------------------------------------------
  const openLogs = async (item) => {
    try {
      setLogsLoading(true);

      const body = new FormData();

      body.append("clientId", item.id);

      body.append(
        "startDate",
        moment().subtract(15, "days").format("YYYY-MM-DD")
      );

      body.append(
        "endDate",
        moment().format("YYYY-MM-DD")
      );

      body.append("filterType", "mobile");
      body.append("filterValue", "");

      const response = await axios.post(
        `${Config.apiUrl}/getactivitylogs`,
        body,
        {
          headers: {
            authorization: "Bearer " + user.token,
            "Content-Type":
              "application/x-www-form-urlencoded; charset=UTF-8",
          },
        }
      );

      const logs = Array.isArray(response?.data?.data)
        ? response.data.data
        : response?.data?.data
          ? [response.data.data]
          : [];

      setActivityLogs(logs);

      // Open modal after API response
      requestAnimationFrame(() => {
        setShowLogs(true);
      });

    } catch (error) {
      console.error("Activity logs error:", error);

      setActivityLogs([]);

      requestAnimationFrame(() => {
        setShowLogs(true);
      });

      toast.error(
        error?.response?.data?.msg || "Failed to load activity logs"
      );

    } finally {
      setLogsLoading(false);
    }
  };
  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />

        {/* <Page> */}
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>{t("Latest Owners")}</Title>
              <Underline />
            </div>
          </div>
          <SideModal
            isOpen={isFilterOpen}
            onClose={() => setIsFilterOpen(false)}
          >
            <FilterModal
              handleClose={() => setIsFilterOpen(false)}
              onApplyFilter={(value) => {
                setAdvancedFilter(value);
                setIsFilterOpen(false);
              }}
              handleClearFilters={() => {
                setAdvancedFilter("");
              }}
              currentFilter={{ value: advancedFilter }}
            />
          </SideModal>

          <div className="flex w-full justify-between items-center">
            <Filters
              submitHandler={submitHandler}
              initialValues={initialValues}
              InitialLoading={isLoadings}
              setFilter={setFilter}
              setFilterValue={setFilterValue}
              ChangeHandler={ChangeHandler}
              filterValue={filterValue}
              filter={filter}
              user={user}
              setIsFilterOpen={setIsFilterOpen}
              setAdvancedFilter={setAdvancedFilter}
              t={t}
            />
          </div>

          <SideModal
            isOpen={showLogs}
            onClose={() => {
              setShowLogs(false);
              setActivityLogs([]);
            }}
          >
            <ActivityLogsModal
              isOpen={showLogs}
              onClose={() => {
                setShowLogs(false);
                setActivityLogs([]);
              }}
              logs={activityLogs}
              loading={logsLoading}
            />
          </SideModal>

          {!error && !isLoadings && data && (
            <TableWrapper>
              <Table
                ApiData={fetchData || []}
                setSelectedData={setSelectedData}
                selectedData={selectedData}
                userType={user.userType}
                openLogs={openLogs}
              />
              {(error || data?.data?.msg === "No data found") && !isLoadings && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}
          {(isLoadings || isRefetching) && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  user,
  filter,
  setFilter,
  setFilterValue,
  filterValue,
  ChangeHandler,
  setIsFilterOpen,
  setAdvancedFilter,
  t,
}) => {
  const today = moment().format("YYYY-MM-DD");
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form className="w-full">
        <FilterContainer>
          <div className="flex gap-2 items-end sm:text-base text-xs flex-wrap">
            <div className="flex items-end gap-2">
              <InputGroup className="max-w-[200px]">
                <Label htmlFor="startDate">{t("Start_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="startDate"
                    id="startDate"
                    className="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>

              <InputGroup className="max-w-[130px]">
                <Label htmlFor="endDate">{t("End_Date")}:</Label>
                <FieldWrapper className="h-10">
                  <img
                    src={Images.Calender}
                    alt="Calender icon"
                    className="w-3.5"
                  />
                  <Field
                    type="date"
                    name="endDate"
                    id="endDate"
                    className="ml-1"
                    max={today}
                  />
                </FieldWrapper>
              </InputGroup>
            </div>
            <ApplyBtn disabled={InitialLoading} type="submit">
              {t("Date_filter")}
            </ApplyBtn>
          </div>
          <div className="flex gap-3 items-end flex-wrap">
            {filter !== "status" && filter !== "paymentMode" ? (
              <InputGroup className="w-[200px]">
                <Field
                  className="border border-gray-300 rounded-md px-3 h-10 w-full focus:ring-1 focus:ring-primary-color focus:border-primary-color"
                  placeholder="Search..."
                  type="text"
                  name="filterVal"
                  id="filterVal"
                  inputMode={filter === "mobile" ? "numeric" : "text"}
                  maxLength={filter === "mobile" ? "10" : undefined}
                  pattern={filter === "mobile" ? "[0-9]*" : undefined}
                  value={filterValue}
                  onChange={(e) => {
                    if (filter === "mobile" || filter === "id") {
                      const value = e.target.value;
                      if (/^\d{0,10}$/.test(value)) {
                        ChangeHandler(e);
                      }
                    } else {
                      ChangeHandler(e);
                    }
                  }}
                />
              </InputGroup>
            ) : null}

            <InputGroup className="" style={{ flexBasis: "content" }}>
              <Label htmlFor="filter">{t("Search By")}</Label>

              <Select
                autoComplete="off"
                className="w-24 px-2 bg-transparent text-sm border-none"
                style={{ height: "40px" }}
                value={filter}
                onChange={(e) => {
                  setFilter(e.target.value);
                  setFilterValue("");
                  setAdvancedFilter("");
                }}
              >
                <MenuItem value="name">Name</MenuItem>
                <MenuItem value="mobile">Phone</MenuItem>
                {/* <MenuItem value="status">Status</MenuItem> */}
                {/* <MenuItem value="id">ID</MenuItem> */}
                {/* {user.userType !== Config.userType.OPERATION && (
                  <MenuItem value="city">City</MenuItem>
                )} */}
              </Select>
            </InputGroup>

            {/* <button
              type="button"
              onClick={() => setIsFilterOpen(true)}
              className="h-10 w-10 flex items-center justify-center border border-gray-300 rounded-md bg-white hover:bg-gray-100"
            >
              <IoFilter size={18} />
            </button> */}
          </div>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.h1`my-10 border  bg-white rounded-md `;
const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;
const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;
export default LatestOwners;
